"use strict";
/**
 * Created on 07 22 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDoc_1 = require("../../../notifications/documents/NotificationDoc");
/**
 * <p>Describes {@link Notification.document} related to notification about deactivated/deleted {@link PromotionArea master area}.</p>
 *
 * <p>Single notification contains mapping of {@link Promotion.id} and related set of deactivated {@link PromotionArea master areas}.</p>
 *
 * @author JMe
 */


var MasterAreaDeactivatedNotification =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(MasterAreaDeactivatedNotification, _NotificationDoc_1$No);

  /**
   * Ctor
   *
   * @param pIdToAreaIds Mapping of {@link Promotion.id} and ids of associated deactivated {@link PromotionArea master areas}.
   */
  function MasterAreaDeactivatedNotification(pIdToAreaIds) {
    var _this;

    _classCallCheck(this, MasterAreaDeactivatedNotification);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MasterAreaDeactivatedNotification).call(this));
    _this.pIdToAreaIds = pIdToAreaIds;
    return _this;
  }

  return MasterAreaDeactivatedNotification;
}(NotificationDoc_1.NotificationDoc);

exports.MasterAreaDeactivatedNotification = MasterAreaDeactivatedNotification;
/**
 * Identification of document related to this notification document.
 */

MasterAreaDeactivatedNotification.DOCUMENT_TYPE = MasterAreaDeactivatedNotification.name;